
ReviewController.$inject = ["$scope", "$http", "$uibModal", "$routeParams", "$location"];
ReviewModalController.$inject = ["$scope", "$uibModalInstance", "$http", "data"];var app = angular.module('stonehenge', ['mwl.calendar',
    'ngRoute',
    'ui.bootstrap',
    'ngAnimate',
    'angular-loading-bar',
    'angularUtils.directives.dirPagination',
    'chart.js',
    'bootstrapLightbox',
    'ngCookies',
    'nvd3', 'daterangepicker']);

function showLoginModal(modalProvider, $rootScope) {
    if (!$rootScope.ON_LOGIN) {
        $rootScope.ON_LOGIN = true;
        var modalInstance = modalProvider.open({
            controller: 'UserLoginController',
            templateUrl: 'src/user/html/user-login-modal.html',
            keyboard: false,
            backdrop: 'static'
        });
    }
}

function errorHandler(error) {
    console.log("Error:", error);
    let e = error.data
    if (e.status && e.message) {
        alert.error(e.message)
        throw new Error(e.message)
    } else {
        alert.error("Something went wrong =(")
        throw new Error("Internal server error")
    }
}

var alert = function () {
    return {
        success: function (message, title, options) {
            toastr.success(message, title || "Success", options)
        },
        warning: function (message, title, options) {
            toastr.warning(message, title || "Warning", options)
        },
        error: function (message, title, options) {
            toastr.error(message, title || "Error", options)
        },
        info: function (message, title, options) {
            toastr.info(message, title || "Info", options)
        },
        clearAll: function () {
            toastr.clear();
        }
    }
} ();

var Promise;

// listeners
app.run(['$rootScope', '$location', '$uibModal', '$uibModalStack', '$window', '$cookies', '$http', '$q',
    function ($rootScope, $location, $uibModal, $uibModalStack, $window, $cookies, $http, $q) {
        Promise = $q;

        $rootScope.$on('$locationChangeStart', function (event, next, current) {
            // checks token every change of url
            if (!$cookies.get('token')) {
                showLoginModal($uibModal, $rootScope);
                event.preventDefault();
            } else {
                $rootScope.token = $cookies.get('token');
            }
        })

        // fired when a response has 403 status
        $rootScope.$on('event:loginRequired', function (event, args) {
            alert.error(args.error);
            showLoginModal($uibModal, $rootScope);
        })

        $rootScope.$on('event:postSignOut', function () {
            delete $cookies.remove('token');
            alert.success("Signed out successfully");
            showLoginModal($uibModal, $rootScope);
        })
    }])

// routes
app.config(['$routeProvider', '$locationProvider', 'LightboxProvider', function ($routeProvider, $locationProvider, LightboxProvider) {
    LightboxProvider.templateUrl = '/assets/lightbox-template.html';

    $routeProvider
        // User
        .when('/users/', {
            controller: 'UserListController',
            templateUrl: 'src/user/html/user-list.html'
        })
        .when('/users/new', {
            controller: 'UserNewController',
            templateUrl: 'src/user/html/user-new.html'
        })
        .when('/users/:id', {
            controller: 'UserEditController',
            templateUrl: 'src/user/html/user-edit.html'
        })

        // Role
        .when('/roles/', {
            controller: 'RoleListController',
            templateUrl: 'src/role/html/role-list.html'
        })
        .when('/roles/new', {
            controller: 'RoleNewController',
            templateUrl: 'src/role/html/role-new.html'
        })
        .when('/roles/:id', {
            controller: 'RoleEditController',
            templateUrl: 'src/role/html/role-edit.html'
        })

        // Company
        .when('/companies/', {
            controller: 'CompanyListController',
            templateUrl: 'src/company/html/company-list.html'
        })
        .when('/companies/new', {
            controller: 'CompanyNewController',
            templateUrl: 'src/company/html/company-new.html'
        })
        .when('/companies/:id', {
            controller: 'CompanyEditController',
            templateUrl: 'src/company/html/company-edit.html'
        })

    // Pictures
    $routeProvider
        .when('/pictures/', {
            controller: 'PictureCalendarController',
            templateUrl: 'src/picture/html/picture-calendar.html'
        })
        .when('/pictures/list', {
            controller: 'PictureListController',
            templateUrl: 'src/picture/html/picture-list.html'
        })

    // Receivers
    $routeProvider
        .when('/receivers/', {
            controller: 'ReceiverListController',
            templateUrl: 'src/receiver/html/receiver-list.html'
        })

    // Forecast
    $routeProvider
        .when('/forecast/', {
            controller: 'ForecastListController',
            templateUrl: 'src/forecast/html/forecast-list.html',
            reloadOnSearch: false
        })
        .when('/forecast/:id', {
            controller: 'ForecastViewController',
            templateUrl: 'src/forecast/html/forecast-view.html'
        })

    // Feedback
    $routeProvider
        .when('/feedback/', {
            controller: 'FeedbackController',
            templateUrl: 'src/feedback/html/feedback.html'
        })
        // stock routes
        .when('/solenoid/', {
            controller: 'StockListController',
            templateUrl: 'src/stock/stock-list.html' 
        })
        .when('/solenoid/:id', {
            controller: 'StockDetailController',
            templateUrl: 'src/stock/stock-detail.html'
        })
        .when('/reviews/:id', {
            controller: 'ReviewController',
            templateUrl: 'src/review/review.html'
        })
        .when('/reviews', {
            controller: 'ReviewController',
            templateUrl: 'src/review/review.html'
        })


        .otherwise({ redirectTo: '/' });
}]);

app.factory('authInterceptor',
['$rootScope', '$q', '$window','$injector','$cookies','cfpLoadingBar',
function($rootScope, $q, $window, $injector,$cookies , cfpLoadingBar) {
    return {
        request: function(config){
            // if ($window.sessionStorage.getItem('token')) {
            //     config.headers['x-stonehenge-token'] = $window.sessionStorage.getItem('token');
            // }
            if ($cookies.get('token')) {
                config.headers['x-stonehenge-token'] = $cookies.get('token');
            }

            return config;
        },
        response: function(response){
            cfpLoadingBar.complete()
            return response;
        },
        responseError : function(rejection) {
            cfpLoadingBar.complete()
            let authError = rejection.status === 403 || rejection.status === 401 || $rootScope.ON_LOGIN === true;
            let ignoreAuth = rejection.config.ignoreAuth === true;

            if (authError && !ignoreAuth){
                if(rejection.status === 401){
                    let message = rejection.data.message || "Sorry, error validating user"
                    $rootScope.$broadcast("event:loginRequired", {error: message});
                }
                if(rejection.status === 403){
                    alert.error(rejection.data.message)
                }
                var deferred = $q.defer();
                return deferred.promise;
            }
            return $q.reject(rejection);
        }
    }
}])


app.config(['$httpProvider', '$routeProvider', function ($httpProvider, $routeProvider) {
    $httpProvider.interceptors.push('authInterceptor')
}]);

app.directive('back', ['$window', function($window) {
    return {
        restrict: 'A',
        link: function (scope, elem, attrs) {
            elem.bind('click', function(){
                $window.history.back();
            });
        }
    };
}]);


app.directive('stRatio',function(){
    return {
        link:function(scope, element, attr){
            var ratio=+(attr.stRatio);

            element.css('width',ratio+'%');

        }
    };
});

app.directive('sort', function() {
    return {
      restrict: 'A',
      transclude: true,
      template:
        '<a ng-click="onClick()" style="color:#333 !important; cursor:pointer">' +
        '<span ng-transclude></span> ' +
        '<i class="fa fa-1" ng-class="{\'fa-chevron-up\' : order === by && !reverse,  \'fa-chevron-down\' : order===by && reverse}"></i>' +
        '</a>',
      scope: {
        order: '=',
        by: '=',
        reverse: '='
      },
      link: function(scope, element, attrs) {
        scope.onClick = function() {
          if (scope.order === scope.by) {
            scope.reverse = !scope.reverse
          } else {
            scope.by = scope.order
            scope.reverse = false
          }
        }
      }
    }
  })


app.directive('hoverClass', function () {
    return {
        restrict: 'A',
        scope: {
            hoverClass: '@'
        },
        link: function (scope, element) {
            element.on('mouseenter', function() {
                element.addClass(scope.hoverClass);
            });
            element.on('mouseleave', function() {
                element.removeClass(scope.hoverClass);
            });
        }
    };
})

CompanyListController.$inject =    ['$scope','companyService'];
function CompanyListController     ($scope, companyService){
    $scope.companies = [];

    let promises = [];

    promises.push(companyService.find({}));

    Promise.all(promises)
    .then(result => {
        $scope.companies = result[0];
    })
}

// Edit controller
CompanyEditController.$inject =    ['$scope', '$routeParams','companyService'];
function CompanyEditController     ($scope, $routeParams, companyService){
    $scope.company = {};

    let company_id = $routeParams.id;
    let promises = [];

    promises.push(companyService.get(company_id));

    Promise.all(promises)
    .then(result => {
        $scope.company = result[0];
    })

    $scope.remove = companyService.remove
    $scope.update = companyService.update
}

// New controller
CompanyNewController.$inject =    ['$scope','companyService'];
function CompanyNewController     ($scope, companyService){
    $scope.company = {};

    let promises = [];

    // Promise.all(promises)
    // .then(result => {
    // })

    $scope.add = companyService.add;
}

app.controller('CompanyEditController', CompanyEditController)
app.controller('CompanyNewController',  CompanyNewController)
app.controller('CompanyListController', CompanyListController)

app.factory('companyService', ['$http', '$location', function($http, $location) {
    return {
        get : function(id) {
            return $http
            .get('api/companies/' + id)
            .then(res => {
                return res.data;
            }, errorHandler);
        },

        add: function(company){
            return $http
            .post('api/companies/add', company)
            .then(res => {
                alert.success("New company saved successfully!");
                $location.path("/companies/");

                return res.data;
            }, errorHandler);
        },

        find: function(filter){
            return $http
            .post('api/companies/', filter)
            .then(res => {
                return res.data;
            }, errorHandler);
        },

        update: function(company){
            return $http
            .put('api/companies/', company)
            .then(res => {
                alert.success("Company updated successfully!")
                $location.path("/companies");

                return res.data;
            }, errorHandler);
        },

        remove: function(id){
            if(confirm("Are you sure?")){

            return $http
            .delete('api/companies/' + id)
            .then(() => {
                alert.success("Company deleted successfully!")
                $location.path("/companies");
            }, errorHandler);
        }
        }
    };
} ]);

// list controller
FeedbackController.$inject = ['$scope','feedbackService'];
function FeedbackController  ($scope, feedbackService){
    $scope.message = {};

    $scope.send = feedbackService.send
}

app.controller('FeedbackController', FeedbackController)

app.factory('feedbackService', ['$http', '$route', function($http, $route) {
    return {
        send : function(message) {
            return $http
            .post('api/feedback/', message)
            .then(res => {
                alert.success("Message sent!");
                $route.reload()
                return res.data;
            }, errorHandler);
        }
    }
}]);

ForecastListController.$inject = ['$scope', '$q', 'forecastService']

function ForecastListController($scope, $q, forecastService) {
  let promises = []
  $scope.filter = { INDIA: true, BRAZIL: true, CHINA: true }
  $scope.forecast = { items: [] }
  $scope.forecast_dc = []
  $scope.dcs = []

  promises.push(forecastService.getView())

  Promise.all(promises).then(results => {
    $scope.forecast.items = results[0]
    console.log($scope.forecast.items.length)
  })

  forecastService.getDCs().then(result => {
    $scope.dcs = _.orderBy(result, 'nome')
  })

  function getForecastByDC() {
    return forecastService.getForecastByDC().then(result => {
      const forecast_dc = result
        // Monta forecast no formato para montar a tabela
        .map(item => {
          let items = result.filter(i => i.id_material_cliente === item.id_material_cliente)

          // Ordena por nome para garantir que o item seja
          // exibido na coluna correta.
          items = _.orderBy(items, 'nome_dc')

          return {
            nome: item.nome,
            id: item.id_programacao_item,
            id_programacao_item: item.id_programacao_item,
            possui_ordem: item.possui_ordem,
            possui_ordem_revisao: item.possui_ordem_revisao,
            id_material_cliente: item.id_material_cliente,
            country: item.country,
            flagSrc: item.flagSrc,
            items, // Armazena pedidos de cada DC
          }
        })
        // Filtra itens sem pedidos ou nada aprovado
        .filter(item => item.items.some(i => i.Pedido > 0 || i.Atendido > 0))

      $scope.forecast_dc = _.uniqBy(forecast_dc, 'id_material_cliente')
    })
  }

  function applyFilter(item) {
    let noFilter = filterObj => Object.keys(filterObj).every(key => !filterObj[key])
    let display = $scope.filter[_.toUpper(item.country)] || noFilter($scope.filter)
    return display
  }

  function findBg(item) {
    const perc = item.Percentual
    const pedido = item.Pedido

    if (pedido !== 0) {
      if (_.inRange(perc, 70, 99999)) return 'bg-green disabled'
      if (_.inRange(perc, 0, 40)) return 'bg-red disabled'
      if (_.inRange(perc, 40, 70)) return 'bg-yellow disabled'
    }
  }

  function viewItem(item) {
    // Busca item correspondente em $scope.forecast
    const matching = $scope.forecast.items.find(i => i.material_id === item.id_material_cliente)

    return forecastService.viewItem(matching)
  }

  getForecastByDC()

  $scope.findBg = findBg
  $scope.getView = forecastService.getView
  $scope.viewItem = viewItem
  $scope.applyFilter = applyFilter
}

ForecastViewController.$inject = ['$scope', 'forecastService', '$routeParams']

function ForecastViewController($scope, forecastService, $routeParams) {
  let item_id = $routeParams.id
  let promises = []
  $scope.item = {}
  $scope.item.bundles = []
  $scope.item.suppliers = []
  $scope.item.data = {}

  $scope.chart = {}
  $scope.supplierChart = {}
  $scope.filter = { ANAHEIM: true, HOUSTON: true, SEATTLE: true }

  let bundlesCache = []

  promises.push(forecastService.getItem(item_id))

  Promise.all(promises)
    .then(results => {
      let item = results[0]
      $scope.item = item
      $scope.totalOrders = item.pedido_lb + item.pedido_h + item.pedido_s
      return item
    })
    .then(item => {
      $scope.chart = forecastService.createDoughnutChart(item)
      return item
    })
    .then(forecastService.getItemData)
    .then(data => {
      $scope.item.bundles = data.bundles
      bundlesCache = data.bundles
      // $scope.supplierChart = forecastService.createSupplierChart(data);

      // TODO remove
      //  $scope.filterNovemberPOs(true)

      return data
    })

  function applyFilter(item) {
    let noFilter = filterObj => Object.keys(filterObj).every(key => !filterObj[key])
    let display = $scope.filter[_.toUpper(item.dc)] || noFilter($scope.filter)
    return display
  }

  $scope.applyFilter = applyFilter
  $scope.openImage = forecastService.openImage
}

app.controller('ForecastListController', ForecastListController)
app.controller('ForecastViewController', ForecastViewController)

app.factory('forecastService', [
  '$http',
  '$location',
  'Lightbox',
  function($http, $location, Lightbox) {
    var item
    var view

    return {
      getForecastByDC: () => {
        return $http
          .get('/api/forecasts/dc')
          .then(res => res.data)
          .then(setItemFlag)
          .catch(errorHandler)
      },

      getDCs: () => {
        return $http
          .get('/api/dcs')
          .then(res => res.data)
          .catch(errorHandler)
      },

      getView: function() {
        if (view) return view //"cache"

        return $http
          .get('/api/forecasts/view')
          .then(res => {
            view = res.data

            return res.data
          }, errorHandler)
          .then(setItemClass)
          .then(setItemFlag)
      },
      viewItem: function(i) {
        item = i

        console.log(item);
        
        $location.path('/forecast/' + item.id)
      },
      getItem: function(id) {
        if (view)
          return _.find(view, i => {
            return i.id == id
          })

        if (!view) {
          return this.getView().then(res => {
            let items = res
            let itemFound = _.find(items, i => {
              return i.id == id
            })
            if (!itemFound) {
              alert.error('Item not found')
            } else {
              return itemFound
            }
          })
        }
      },
      getItemData: function(item) {
        if (
          item['atendido_lb'] === 0 && 
          item['atendido_h'] === 0 && 
          item['atendido_s'] === 0) {
            return { bundles: [] }
          }

        let material_id = item['material_id']

        alert.info("<i class='fa fa-refresh fa-spin fa-fw'></i> Searching bundles...", 'Info', {
          timeOut: 0,
          extendedTimeOut: 0,
        })

        return $http
          .get('/api/forecasts/view/' + material_id)
          .then(res => res.data)
          .then(itemData => {
            alert.clearAll()
            alert.success('Bundles loaded!')
            return itemData
          })
      },
      createDoughnutChart: function(item) {
        let inspected = _.max([item.atendido_lb + item.atendido_h, 0])
        let balance = _.max([item.balance_lb + item.balance_h, 0])

        let labels = ['Inspected', 'Balance']
        let colors = ['#00A65A', '#dcdcdc']
        return {
          labels: labels,
          data: [inspected, balance],
          colors: colors,
        }
      },
      createSupplierChart: function(itemData) {
        let suppliers = itemData.suppliers
        let chart = {}
        chart.suppliers = []
        chart.totals = []

        _.forEach(suppliers, s => {
          chart.suppliers.push(s['fornecedor_nome'])
          chart.totals.push(s['total'])
        })

        chart.colors = ['#00a7d0', '#00c0ef', '#5ad6f8']

        return chart
      },
      openImage: function(bundles, index) {
        let images = []

        _.forEach(bundles, b => {
          let caption = "<div class='row'>"
          caption += "     <div class='col-lg-5 col-xs-5'>"
          caption +=
            "        <span class='pull-left'>" + (b['serial'] == null ? '' : b.serial) + '</span>'
          caption += '    </div>'
          caption += "     <div class='col-lg-2 col-xs-2'>"
          caption +=
            "        <span class='text-center'>" + _.toString(b['medida_cavalete']) + '</span>'
          caption += '    </div>'
          caption += "     <div class='col-lg-5 col-xs-5'>"
          caption += "        <span class='pull-right'>" + b['grade'] + '</span>'
          caption += '    </div>'
          caption += '</div>'

          let url = b['url']
          images.push({ caption, url })
        })
        Lightbox.openModal(images, index)
      },
    }
  },
])

function setItemClass(items) {
  _.forEach(items, item => {
    item.classLb = ''
    item.classH = ''
    let veryHighNumber = 100000

    if (item['pedido_lb'] !== 0) {
      if (_.inRange(item['percentual_lb'], 70, veryHighNumber)) item.classLb = 'bg-green disabled'
      if (_.inRange(item['percentual_lb'], 0, 40)) item.classLb = 'bg-red disabled'
      if (_.inRange(item['percentual_lb'], 40, 70)) item.classLb = 'bg-yellow disabled'
    }

    if (item['pedido_h'] !== 0) {
      if (_.inRange(item['percentual_h'], 70, veryHighNumber)) item.classH = 'bg-green disabled'
      if (_.inRange(item['percentual_h'], 0, 40)) item.classH = 'bg-red disabled'
      if (_.inRange(item['percentual_h'], 40, 70)) item.classH = 'bg-yellow disabled'
    }
  })
  return items
}

// TODO: make this dynamic
function setItemFlag(items) {
  _.forEach(items, item => {
    item.flagSrc = ''

    // if(item["empresa_id"] === 1) item.flagSrc = "https://s3-us-west-2.amazonaws.com/stonehenge-assets/flags/china.svg";
    // if(item["empresa_id"] === 2) item.flagSrc = "https://s3-us-west-2.amazonaws.com/stonehenge-assets/flags/china.svg";
    // if(item["empresa_id"] === 5) item.flagSrc = "https://s3-us-west-2.amazonaws.com/stonehenge-assets/flags/china.svg";

    if (item.id_empresa === 1) {
      item.flagSrc = 'assets/flags/brazil.svg'
      item.country = 'brazil'
    }
    if (item.id_empresa === 2) {
      item.flagSrc = 'assets/flags/india.svg'
      item.country = 'india'
    }
    if (item.id_empresa === 5) {
      item.flagSrc = 'assets/flags/china.svg'
      item.country = 'china'
    }
  })
  return items
}

function indexController($rootScope, $scope,indexService , menuService){
    $scope.menus = []
    $scope.user = {}

    $rootScope.$watch('token', function(newValue, oldValue) {
        if(newValue != oldValue){
            $scope.user = $rootScope.user;

            menuService.get()
            .then((menus) => {
                $scope.menus = menus;
            })
        }
    })
    $rootScope.$on("USER_LOGGED", function(value){
        menuService.get()
        .then((menus) => {
            $scope.menus = menus;
        })
    })
    // menuService.get()
    // .then((menus) => {
    //     $scope.menus = menus;
    //     // console.log(menus);
    // })

    $scope.signOut = indexService.signOut;
}

indexController.$inject = ['$rootScope', '$scope', 'indexService', 'menuService']

app.controller('indexController', indexController)

app.factory('indexService', [ '$http','$rootScope', function($http, $rootScope) {
    return {
        signOut : function(){
            $rootScope.$broadcast('event:postSignOut')
            // $http.get('/api/signout')
            // .then(result => {
            // })
        }
    };
} ]);


app.factory('menuService', [ '$http', function($http) {
    return {
        get : function(id) {
            return $http.get('api/menu/')
            .then(res => {
                return res.data;
            }, errorHandler)
        }
    }
} ]);

app.factory('paperworkService', [ '$http', function($http) {
    return {
        getByDeparture: function(date){
            return $http.get('/api/paperwork/departure/ ' + _.toString(date))
            .then(res => {
                return res.data
            }, errorHandler)
        }
    };
} ]);

// Calendar Controller
PictureCalendarController.$inject = ['$scope','pictureService'];
function PictureCalendarController($scope, pictureService){
    let eventsCopy = [];
    $scope.events       = [];
    $scope.calendarView = 'month';
    $scope.calendarDate = new Date();
    $scope.filter = "All";

    pictureService
    .findEvents()
    .then(events => $scope.events = eventsCopy = events);


    $scope.updateCalendar = updateCalendar
    $scope.openEvent = pictureService.openEvent;

    function updateCalendar(countryName){
        let country = _.toUpper($scope.filter);

        if(country === _.toUpper("brazil")) $scope.events = _.filter(eventsCopy, (ev) => ev.title.indexOf("Brazil") > -1);
        if(country === _.toUpper("india"))  $scope.events = _.filter(eventsCopy, (ev) => ev.title.indexOf("India") > -1);
        if(country === _.toUpper("china"))  $scope.events = _.filter(eventsCopy, (ev) => ev.title.indexOf("China") > -1);
        if(country === _.toUpper("all"))  $scope.events = eventsCopy;
    }

    $scope.showNewPicturesAlert = false;
    if(moment().isBefore(moment('2016-11-22'))){
        $scope.showNewPicturesAlert = true;
    }else{
        $scope.showNewPicturesAlert = false;
    }
}

function PictureListController($scope, $routeParams, pictureService){
    $scope.pos = [];
    $scope.stats = {}
    $scope.pictureFilter = false;

    let findPoList = () => {
        pictureService.findPoList().then(pos => {
            $scope.pos = pos
            $scope.stats.downloaded = _.filter(pos, po => po.isDownloaded === true).length;
            $scope.stats.nonDownloaded = pos.length - $scope.stats.downloaded;
        });
    }

    function filterDownloaded(item){
        if($scope.pictureFilter == true) return true;
        if($scope.pictureFilter == false) return item.isDownloaded == false;
    }

    $scope.downloadPictures = pos => {
      pictureService.downloadPictures(pos, void 0)//.then(() => findPoList())
    }
    $scope.downloadNonDownloaded = pictureService.downloadNonDownloaded
    $scope.downloadBulk = pictureService.downloadBulk
    $scope.filterDownloaded = filterDownloaded;

    findPoList();
}

function PictureModalController($scope, $uibModalInstance, pictureService, calendarEvent){
    $scope.POs       = [];
    $scope.eventDate = new Date(calendarEvent.startsAt);
    $scope.calendarEvent = calendarEvent;

    function ok()       { $uibModalInstance.close() };
    function close()    { $uibModalInstance.dismiss('cancel') };

    function findPOs(){
        pictureService.findPOs(calendarEvent)
        .then(pos => $scope.POs = pos);
    };
    findPOs();

    $scope.ok = ok;
    $scope.close = close;
    $scope.downloadPictures = (pos, date) => { pictureService.downloadPictures(pos,date).then(() => findPOs()); };
}

function PictureNewController($scope, pictureService){
}

PictureNewController.$inject = ['$scope','pictureService']
PictureListController.$inject = ['$scope','$routeParams','pictureService']
PictureModalController.$inject = ['$scope','$uibModalInstance','pictureService','calendarEvent']

app.controller('PictureCalendarController', PictureCalendarController)
app.controller('PictureNewController',  PictureNewController)
app.controller('PictureListController', PictureListController)
app.controller('PictureModalController', PictureModalController)

app.factory('pictureService', ['$http', '$uibModal', 'cfpLoadingBar', 'paperworkService',
    function ($http, $uibModal, cfpLoadingBar, paperworkService) {

        var POs;

        return {
            findEvents: function () {
                return $http.get('/api/pictures/calendar')
                    .then(res => res.data, errorHandler)
                    .then(events => _.map(events, ev => {
                        ev.startsAt = moment(ev.startsAt).toDate();
                        return ev;
                    }))
            },

            openEvent: function (event) {
                let modalInstance = $uibModal.open({
                    controller: 'PictureModalController',
                    templateUrl: 'src/picture/html/picture-calendar-modal.html',
                    keyboard: true,
                    animation: false,
                    resolve: {
                        calendarEvent: function () {
                            return event;
                        }
                    }
                });
                return modalInstance;
            },

            findPOs: function (event) {
                let filter = {
                    "data_saida": event.startsAt,
                    "id_empresa": event.id_empresa
                };

                return $http.post('/api/pictures/departure', filter)
                    .then(res => res.data, errorHandler)
                    .then(pos => _.map(pos, po => { po.isDownloaded ? po.situation = "Downloaded" : ""; return po }))
                    .then(result => { POs = result; return result });
            },

            findPoList: function () {

                alert.info("<i class='fa fa-refresh fa-spin fa-fw'></i> Searching pictures...", "Info", { "timeOut": 0, "extendedTimeOut": 0 });

                // return $http.get('/api/pictures/list')
                return $http.get('/api/v2/pictures/list')
                    .then(res => res.data, errorHandler)
                    .then(pos => _.orderBy(pos, 'isDownloaded', 'asc'))
                    .then(pos => {
                        alert.clearAll();
                        return pos;
                    })
                // .then(pos => _.map(pos, po => { po.isDownloaded ? po.situation = "Downloaded" : ""; return po }))
            },

            downloadBulk: function (pos){
                if(!confirm("Are you sure? This will set all POs as 'Downloaded' and clear the list")) return

                const nonDownloaded = _.filter(pos, po => po.isDownloaded === false)
                const poNumbers = _.map(nonDownloaded, 'poNumber')

                console.log(poNumbers)

                $http.post('/api/pictures/download-bulk', poNumbers)
                .catch(errorHandler)
                .then(res => res.data)
                .then(() => {
                    alert.info('Resquet sent. <br>We will process the pictures and send you an email in a few minutes')
                })
            },


            downloadPictures: function (pos, date) {
                let zip = new JSZip();
                let urls = []
                let errors = [];
                let folder = {};
                let folderName = "";
                let alertMessage = {};

                pos = _.castArray(pos);

                if (pos.length == 1) folderName = pos[0].poNumber;
                if (pos.length > 1 && date) folderName = moment(date).format('YYYY-MM-DD');

                // folder = zip.folder(folderName);

                urls = _.map(pos, po => po.poUrl);
                pos = _.map(pos, po => po.poNumber);

                return $http.post('/api/v2/pictures/download', { "pos": pos })
                    .then(res => res.data, errorHandler)
                    // .then(r => { console.log(r); return r})
                    // .then(files => { alertMessage = showDownloadingAlert(files.length); return files; })
                    // .then(r => { console.log(r); return r})
                    // .then(files => _.map(files, file => getBinary(file, $http, errors)))
                    // .then(Promise.all)
                    .then(r => { console.log(r); return r })
                    // .then(result => { handlePictureError(errors); return result})
                    .then(files => _.map(files, file => addToZip(file, zip)))
                    .then(files => createZipFile(zip, folderName))
                    .then(() => $http.post('/api/pictures/downloaded', { "pos": pos }))
                    // .then(newPos => { toastr.clear(alertMessage); return newPos; })
            },

            downloadNonDownloaded: function (poList) {
                let nonDownloaded = _.filter(poList, po => po.isDownloaded === false);

                // baixa só os 40 primeiros pois estava dando problema de timeout
                nonDownloaded = _.slice(nonDownloaded, 0, 25)

                return this.downloadPictures(nonDownloaded, undefined);
            }

        };
    }]);

function addToZip(file, folder) {
    folder.file(file.file_name, file.bin, { "base64": true })
    return file;
}

function createZipFile(zipProvider, zipName) {
    zipProvider.generateAsync({ type: "blob" })
        .then(function (content) {
            saveAs(content, _.toString(zipName) + ".zip");
        });
}

function getBinary(file, http, errors) {
    let File = (name, bin) => { return { bin: bin, file_name: name } };
    let config = { responseType: "arraybuffer", ignoreLoadingBar: true, ignoreAuth: true };

    return http.get(file.url, config)
        .catch(error => {
            console.log('Error:' + error)
            errors.push(file.file_name);
            return undefined;
        })
        .then(res => {
            if (res) return res.data
            return undefined;
        })
        .then(bin => {
            if (bin) return File(file.file_name, bin)
            return undefined;
        })
}

function handlePictureError(errors) {
    if (errors.length > 0) {
        toastr.clear();
        let message = "<p> The pictures below are not available: </p>";
        _.forEach(errors, e => message += "<p style='font-size:13px'><i>" + e + "</p>");
        alert.error(message, "Error", { "timeOut": 0, "extendedTimeOut": 0 })

        throw new Error("Error downloading pictures");
    }
}

function showDownloadingAlert(imageQty) {
    let config = { "timeOut": 0, "extendedTimeOut": 0 };
    if (imageQty > 7) {
        let message = "Downloading " + imageQty + " pictures <i class='fa fa-refresh fa-spin fa-fw'></i>";
        return toastr.info(message, "Info", config);
    }
    return toastr.info("Downloading pictures <i class='fa fa-refresh fa-spin fa-fw'></i>", "Info", config);
}
function ReceiverListController($scope, $q, receiverService){
    let promises = [];
    $scope.receivers = [];
    $scope.filter = {"BRAZIL": true, "INDIA": true, "CHINA": true};

    promises.push(receiverService.find({}));

    Promise.all(promises)
    .then(results => {
        $scope.receivers = results[0];
    })

    // functions
    function applyFilter(item){
        let noFilter = (filterObj) => Object.keys(filterObj).every(key => !filterObj[key])
        let display =  $scope.filter[_.toUpper(item.pais)] || noFilter($scope.filter);
        return display;
    }

    $scope.applyFilter = applyFilter;
    $scope.get = receiverService.get;

}

ReceiverListController.$inject = ['$scope','$q','receiverService']

app.controller('ReceiverListController', ReceiverListController)

app.factory('receiverService', [ '$http', function($http) {
    return {
        get : function(po) {
            return $http({url: '/api/receivers/'+ _.toString(po),  responseType: "arraybuffer"})
            .then(res => {
                var blob = new Blob([res.data], {type: "application/vnd.ms-excel"})
                saveAs(blob, _.toString(po) + ".xls");
            })
            .catch(err => {
                alert.warning("Receiver not available yet");
                throw new Error("Receiver not available yet");
            })
        },
        find : function(filter){
            return $http.post('/api/receivers/', filter)
            .then(res => {
                return _.orderBy(res.data, ['numero_po', 'desc']);
            }, errorHandler)
        },
        request: function(po){

        }
    };
} ]);

// list controller
RoleListController.$inject =    ['$scope','roleService'];
function RoleListController     ($scope, roleService){
    $scope.roles = [];
    let promises = [];

    promises.push(roleService.find({}))

    Promise.all(promises)
    .then(result => {
        $scope.roles = result[0];
    })
}

// Edit controller
RoleEditController.$inject =    ['$scope', '$routeParams','roleService', 'companyService'];
function RoleEditController     ($scope, $routeParams, roleService, companyService){
    $scope.role = {};
    $scope.companies = [];

    let role_id = $routeParams.id;
    let promises = [];

    promises.push(roleService.get(role_id));
    promises.push(companyService.find({}));

    Promise.all(promises)
    .then(result => {
        $scope.role = result[0];
        $scope.companies = result[1];
    })

    $scope.remove = roleService.remove
    $scope.update = roleService.update
}

// New controller
RoleNewController.$inject =    ['$scope','roleService','companyService'];
function RoleNewController     ($scope, roleService, companyService){
    $scope.role = {};
    $scope.companies = [];
    let promises = [];

    promises.push(companyService.find({}));

    Promise.all(promises)
    .then(result => {
        $scope.companies = result[0];
    })

    $scope.add = roleService.add;
}

app.controller('RoleEditController', RoleEditController)
app.controller('RoleNewController', RoleNewController)
app.controller('RoleListController', RoleListController)

app.factory('roleService', ['$http', '$location', function($http, $location) {
    return {
        get : function(id) {
            return $http
            .get('api/roles/' + id)
            .then(res => {
                return res.data;
            }, errorHandler);
        },

        add: function(role){
            return $http
            .post('api/roles/add', role)
            .then(res => {
                alert.success("New role saved successfully!");
                $location.path("/roles/");

                return res.data;
            }, errorHandler);
        },

        find: function(filter){
            return $http
            .post('api/roles/', filter)
            .then(res => {
                return res.data;
            }, errorHandler);
        },

        update: function(role){
            return $http
            .put('api/roles/', role)
            .then(res => {
                alert.success("Role updated successfully!")
                $location.path("/roles");

                return res.data;
            }, errorHandler);
        },

        remove: function(id){
            if(confirm("Are you sure?")){

            return $http
            .delete('api/roles/' + id)
            .then(() => {
                alert.success("Role deleted successfully!")
                $location.path("/roles");
            }, errorHandler);
        }
        }
    };
} ]);

UserLoginController.$inject = ['$scope','$uibModalInstance','userService']
function UserLoginController($scope, $uibModalInstance,userService){
    $scope.user = {};
    $scope.emailResetPassword = "";
    $scope.showFormNewPassword = false;


    function login(user){
        userService.login(user)
        .then(res =>  $uibModalInstance.close())
    }

    $scope.login = login;
    $scope.requestPasswordReset = userService.requestPasswordReset;
    $scope.togglePasswordResetForm = () => $scope.showFormNewPassword = !$scope.showFormNewPassword
}

UserListController.$inject = ['$scope','userService']
function UserListController($scope, userService){
    $scope.users = [];
    $scope.currentPage = 1;

    function list(){
        userService.find()
        .then((users) => $scope.users = users)
    }

    list()

    $scope.list = list;
}

UserEditController.$inject = ['$scope','$routeParams', 'userService', 'companyService', 'roleService']
function UserEditController($scope, $routeParams, userService, companyService,roleService){
    let userId = $routeParams.id;
    $scope.user = {};
    $scope.user.roles = [];
    $scope.companies = {};

    let promises = [];

    promises.push(userService.get(userId));
    promises.push(companyService.find({}));
    promises.push(roleService.find({}));

    Promise.all(promises)
    .then(result => {
        $scope.user = result[0];
        $scope.companies = result[1];
        $scope.roles = userService.checkUserRoles(result[2], $scope.user);
    })

    $scope.addRole = userService.addRole;
    $scope.update = userService.update;
}

UserNewController.$inject = ['$scope', 'userService', 'companyService', 'roleService'];
function UserNewController($scope, userService, companyService, roleService){
    $scope.user = {};
    $scope.user.roles = [];

    let promises = [];

    promises.push(companyService.find({}));
    promises.push(roleService.find({}));

    Promise.all(promises)
    .then(result => {
        $scope.companies = result[0];
        $scope.roles = result[1];
    })

    $scope.add = userService.add;
}


app.controller('UserLoginController', UserLoginController)
app.controller('UserListController', UserListController)
app.controller('UserNewController', UserNewController)
app.controller('UserEditController', UserEditController)

app.factory('userService', [ '$rootScope', '$http','$window', '$route','$location' ,'$cookies',
function($rootScope,$http, $window, $route, $location, $cookies) {
    return {
        requestPasswordReset: function(email){
            return $http.post("/password-reset/email", {"email": email}, {ignoreAuth: true})
            .then(res => {
                alert.success("Email sent! Please check your inbox");
                return res;
            }, errorHandler)
        },
        get : function(id) {
            return $http
            .get('api/users/' + id)
            .then(res => {
                return res.data;
            }, errorHandler);
        },

        add: function(user){
            return $http
            .post('api/users/add', user)
            .then(res => {
                let user_id = res.data["id"]
                alert.success("New user saved successfully!");
                $location.path("/users/" + user_id);
                return res.data;
            }, errorHandler);
        },

        find: function(filter){
            return $http
            .post('api/users/', filter)
            .then(res => {
                return res.data;
            }, errorHandler);
        },

        update: function(user){
            return $http
            .put('api/users/', user)
            .then(res => {
                alert.success("User updated successfully!")

                return res.data;
            }, errorHandler);
        },

        remove: function(id){
            if(confirm("Are you sure?")){
                return $http
                .delete('api/users/' + id)
                .then(() => {
                    alert.success("User deleted successfully!")
                    $location.path("/users");
                }, errorHandler);
            }
        },

        login: function(credentials){
            return $http.post('/api/authenticate', credentials)
            .then(res => {
                let token = res.data.token
                let user = {
                    "nome": res.data["nome"],
                    "empresa_nome": res.data["empresa_nome"],
                    "email": res.data["email"]
                }
                $cookies.put('token', token, {"expires": moment().add(1, 'days').toDate()})

                alert.success("You are now logged in");

                $rootScope.ON_LOGIN = false;


                $rootScope.user = user;
                $rootScope.$emit("USER_LOGGED", user);
                $route.reload()
                return user; //TODO proper return
            },
            (err) => {
                $rootScope.ON_LOGIN = false;
                // $window.sessionStorage.removeItem('token');
                $cookies.remove('token');
                errorHandler(err)
            })
        },

        addRole(role, user){
            if(_.isEmpty(user.roles)) user.roles = [];

            if(_.find(user.roles, (ur) => {return ur.id === role["id"]})){
                _.remove(user.roles, (ur) => {return ur.id === role["id"]})
            }else{
                user.roles.push(role);
            }

            return user;
        },

        checkUserRoles: function(roles, user){
            _.forEach(roles, (role)=> {
                if(!_.isEmpty(_.find(user.roles, (ur) => {return ur["id"] === role["id"]}))){
                    role.checked = true;
                }else{
                    role.checked = false;
                }
            })
            return roles;
        }
    };
} ]);


app.factory('voyageService', [ '$http' ,function($http) {
    return {
        get : function(id) {
        },

        add: function(vessel){
        },

        find: function(filter){
            return $http
            .post('api/voyages/', filter)
            .then(res => {
                return res.data;
            }, errorHandler)
        },

        update: function(vessel){
        },

        remove: function(id){
        }
    };
} ]);

angular.module('stonehenge')
.factory('componentService', [ '$http', function($http) {
    return {
        get : function(id) {
            return $http.get('api/users/' + id)
        },
        add: function(user){
            return $http.post('api/users/add', user)
        },
        find: function(filter){
            return $http.post('api/users/', filter)
        },
        update: function(user){
            return $http.put('api/users/update', user)
        },
        remove: function(id){
            return $http.delete('api/users/' + id)
        }
    };
} ]);

app
  .controller('ReviewController', ReviewController)
  .controller('ReviewModalController', ReviewModalController)

function ReviewController($scope, $http, $uibModal, $routeParams, $location) {
  'ngInject'

  $scope.inspecoes = []
  $scope.inspecao = {}

  function getInspections() {
    return $http
      .get('/api/v2/inspections-review')
      .then(res => res.data)
      .then(inspecoes => {
        $scope.inspecoes = inspecoes
        if (inspecoes.length === 0) $scope.nothingFound = true
      })
      .catch(errorHandler)
      .then(() => {
        $location.path('/reviews')
      })
  }

  function viewInspection(inspecao) {
    return $http
      .get('/api/v2/inspection/' + inspecao.id)
      .then(res => res.data)
      .then(inspecao => {
        $scope.inspecao = inspecao
      })
      .catch(errorHandler)
  }
  if ($routeParams.id) {
    viewInspection({ id: $routeParams.id })
  }

  function openBundleModal(arquivo) {
    $uibModal.open({
      templateUrl: 'src/review/review-modal.html',
      controller: 'ReviewModalController',
      size: 'lg',
      resolve: {
        data: function() {
          return {
            arquivo: arquivo,
            inspecao: $scope.inspecao,
          }
        },
      },
    })
  }

  $scope.saveReview = () => {
    let { observacao_externa, id } = $scope.inspecao

    if (!observacao_externa) {
      observacao_externa = 'N/a'
    }
    
    $http
      .post('/api/v2/send-review', {
        id,
        observacao_externa
      })
      .then(() => {
        alert.success('Submitted')
        $scope.inspecao = {}
        getInspections()
      })
      .catch(errorHandler)
  }

  getInspections()

  $scope.viewInspection = viewInspection
  $scope.openBundleModal = openBundleModal
}

function ReviewModalController($scope, $uibModalInstance, $http, data) {
  'ngInject'

  $scope.inspecao = data.inspecao
  $scope.arquivo = data.arquivo

  
  $scope.saveReview = () => {
    $http
      .post('/api/v2/review', $scope.arquivo)
      .then(() => {
        alert.success('Comment saved')
      })
      .catch(errorHandler)
  }

  $scope.close = $uibModalInstance.close
}

StockListController.$inject = ['$scope', 'stockService'];
function StockListController($scope, stockService) {

    stockService.find()
        .then(result => {
            $scope.stock = result;
        });

    stockService.findStats()
        .then(result => {
            $scope.chart = {};
            $scope.chart.labels = _.map(result, (r) => r.risco);
            $scope.chart.data = _.map(result, (r) => r.total);
            $scope.chart.colors = ['#dd4b39', '#f39c12', '#00a65a', '#3c8dbc'];

        });
}
app.controller('StockListController', StockListController);

/**
 * Stock-PO Modal Controller
 */
stockPOModalController.$inject = ['$scope', '$uibModalInstance', 'stockService', 'modalData'];
function stockPOModalController($scope, $uibModalInstance, stockService, modalData) {
    const dateClicked = modalData.dateClicked;
    const materialId = modalData.materialId;
    $scope.materialName = modalData.materialName;

    $scope.pos = [];
    $scope.poSelected = '';
    $scope.dateClicked = dateClicked;
    $scope.pictures = [];
    $scope.posLoading = true;
    $scope.picturesLoading = false;

    stockService.getStockPOs(materialId, dateClicked)
        .then(result => {
            $scope.posLoading = false;
            $scope.pos = result;
        }).catch(err => { $scope.posLoading = false; return err; })

    function selectPO(poNumber, inspectionId) {
        if (!inspectionId) {
            alert.error("This PO is only available in P21");
            return;
        }

        $scope.poSelected = poNumber;
        $scope.picturesLoading = true;

        stockService.getStockPOsByInspection(materialId, inspectionId)
            .then(result => {


                $scope.picturesLoading = false;
                $scope.pictures = result;

            }).catch(err => { $scope.picturesLoading = false; return err; })
    }

    $scope.selectPO = selectPO;
    $scope.close = $uibModalInstance.close;
}
app.controller('stockPOModalController', stockPOModalController);

currentStockModalController.$inject = ['$scope', '$uibModalInstance', 'stockService', 'modalData'];
function currentStockModalController($scope, $uibModalInstance, stockService, modalData) {
    const dateClicked = modalData.dateClicked;
    const materialId = modalData.materialId;
    $scope.materialName = modalData.materialName;

    stockService.getDistributionCenterStock(materialId)
        .then(result => {
            $scope.locationStock = result
            $scope.totalStock = _.round(_.reduce(result, (sum, r) => {
                return sum + (r.QtyOnHand - r.QtyAllocated)
            }, 0))
        })

    $scope.close = $uibModalInstance.close;
}
app.controller('currentStockModalController', currentStockModalController);

/**
 * Stock Detail Controller
 */
StockDetailController.$inject = ['$scope', '$routeParams', '$window', '$uibModal', 'stockService', 'stockUtil'];
function StockDetailController($scope, $routeParams, $window, $uibModal, stockService, stockUtil) {
    const materialId = $routeParams.id;
    $scope.materialId = materialId;
    $scope.stockChart = {};
    $scope.backOrderSimulationChart = {};
    $scope.oldAgedSimulationChart = {};
    $scope.userSimulationChart = {};
    $scope.salesChart = {};
    $scope.salesChartData = {};
    $scope.poList = [];
    $scope.stockItem = {};
    $scope.sales = {};
    $scope.checkboxSplit = false;
    $scope.activeTabIndex = stockService.getActiveTab();
    $scope.datePicker = {};
    $scope.chartLoading = true;
    $scope.stockSalesChartLoading = false;
    $scope.salesChartLoading = false;
    $scope.geochartLoading = false;
    $scope.loadingSomething = false;
    $scope.posLoading = false;
    $scope.radioSales = 'zeroTo12';
    $scope.radioSimulation = 'DEFAULT_SIMULATION';
    $scope.currentMaterial = stockService.currentMaterial;
    $scope.userChartInput = {}
    $scope.userChartInput.simulatedAvgSales = $scope.stockItem.media_vendas * 30;
    $scope.userChartInput.interactivityCheckbox = true;

    let stockChartCache = void 0;
    let regionalSalesCache = void 0;
    let salesStockCache = void 0;
    let pointsClicked = [];

    $scope.datePicker.date = { startDate: null, endDate: null };
    $scope.datePicker.options = stockUtil.getDatepickerOptions(applyDateFilter)

    // finds stock list with materials
    stockService.find(materialId)
        .then(result => {
            $scope.stockList = result;
        });


    /**
    * Simulation Chart (Stock)
    */
    function handlePointClick(pointClicked, stockHistory, simulations) {
        const lastHistoryDate = moment(_.max(_.map(stockHistory, point => new Date(point.x)))).format('YYYY-MM-DD');
        const dateClicked = moment(pointClicked.point.x).format('YYYY-MM-DD');
        const isFirstSimulationDate = moment(_.min(_.map(_.flattenDeep(simulations), s => s.x))).isSame(dateClicked)

        // console.log(lastHistoryDate);
        // console.log(dateClicked);
        // console.log(moment(lastHistoryDate).isSame(dateClicked));
        // console.log(pointClicked.point.id);

        if ((pointClicked.point.id === 0 && moment(lastHistoryDate).isSame(dateClicked)) || isFirstSimulationDate) {
            return showCurrentStockModal(pointClicked);
        }
        if (pointClicked.point.id === 0) {
            return calculateMeanPoint(pointClicked, stockHistory);
        }
        if (_.includes([1, 2, 3, 4, 5, 6], pointClicked.point.id)) {
            return showPOModalPoint(pointClicked);
        }
    }

    function showCurrentStockModal(clicked) {
        const dateClicked = clicked.point.x;

        const modalInstance = $uibModal.open({
            controller: 'currentStockModalController',
            templateUrl: 'src/stock/stock-current-modal.html',
            keyboard: true,
            size: 'lg',
            animation: false,
            resolve: {
                modalData: function () {
                    const materialName = $scope.currentMaterial;
                    return { dateClicked, materialId, materialName };
                }
            }
        });
    }

    function calculateMeanPoint(clicked, stockHistory) {
        if ($scope.userChartInput.interactivityCheckbox == false) return;

        pointsClicked.push(clicked.point);
        if (pointsClicked.length > 1) {
            const lastTwoPointsClicked = _.takeRight(pointsClicked, 2);
            const highestDatePoint = _.max(_.map(lastTwoPointsClicked, lpc => lpc.x))
            const lowestDatePoint = _.min(_.map(lastTwoPointsClicked, lpc => lpc.x))
            const rangeBetweenTwoPoints = _.filter(stockHistory, (point) => {
                return new Date(point.x) >= new Date(lowestDatePoint)
                    && new Date(point.x) <= new Date(highestDatePoint);
            })

            // const averageStockInRange = _.round(_.meanBy(rangeBetweenTwoPoints, 'y'));
            // console.log(lastTwoPointsClicked[0].y);
            // console.log(lastTwoPointsClicked[1].y);
            // console.log('point - :',Math.abs(lastTwoPointsClicked[0].y - lastTwoPointsClicked[1].y));
            // console.log('lengh :',rangeBetweenTwoPoints.length);
            // console.log('---------')
            const averageStockInRange = _.round((Math.abs(lastTwoPointsClicked[0].y - lastTwoPointsClicked[1].y) / rangeBetweenTwoPoints.length) * 30)


            $scope.userChartInput.simulatedAvgSales = averageStockInRange

            // const message = 'Average stock between ' + moment(lowestDatePoint).format('MMM Do') +
            //     ' and ' + moment(highestDatePoint).format('MM Do') +
            //     ' is ' + averageStockInRange + ' sq. ft.';

            const message = 'Average stock between dates is:   ' +
                averageStockInRange.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") +
                ' sq. ft.';

            $scope.stockChartStatus = message;
            $scope.$apply();
            pointsClicked = [];
            return;

        }
        return;
    }

    function showPOModalPoint(clicked) {
        const dateClicked = clicked.point.x;

        const modalInstance = $uibModal.open({
            controller: 'stockPOModalController',
            templateUrl: 'src/stock/stock-po-modal.html',
            keyboard: true,
            size: 'lg',
            animation: false,
            resolve: {
                modalData: function () {
                    const materialName = $scope.currentMaterial;
                    return { dateClicked, materialId, materialName };
                }
            }
        });
    }
    function createSimulationChart() {
        // not the first time the tab is clicked
        if (stockChartCache) {
        } else {
            Promise.all(
                [stockService.get(materialId),
                stockService.getChart(materialId)])
                .then(results => {
                    $scope.chartLoading = false;
                    $scope.currentMaterial = results[0].nome_material;

                    $scope.stockItem = results[0];
                    $scope.stockChart.data = [];
                    $scope.stockChart.options = stockUtil.getOptions(function (click) {
                        // handles clicks on different parts of the chart 
                        return handlePointClick(click, results[1].history, _.filter(results[1], r => r[0] && r[0].id != 0))
                    });

                    // month bars
                    $scope.stockChart.data.push(stockUtil.createBar($scope.stockItem, "#e98a7e"));
                    $scope.stockChart.data.push(stockUtil.createBar($scope.stockItem, "#e2c391"));
                    $scope.stockChart.data.push(stockUtil.createBar($scope.stockItem, "#87d0e2"));

                    // history chart
                    $scope.stockChart.data.push(stockUtil.createLine(results[1].history, "red", "Stock"));

                    // reference lines
                    $scope.stockChart.data.push(stockUtil.createReferenceLine(results[1], $scope.stockItem.media_vendas, 0, "red", true));
                    $scope.stockChart.data.push(stockUtil.createReferenceLine(results[1], $scope.stockItem.media_vendas, 30, "#5a6e82", true));
                    $scope.stockChart.data.push(stockUtil.createReferenceLine(results[1], $scope.stockItem.media_vendas, 60, "#5a6e82", true));
                    $scope.stockChart.data.push(stockUtil.createReferenceLine(results[1], $scope.stockItem.media_vendas, 49, "#0073b7"));

                    // ----- other charts get same configurations
                    $scope.backOrderSimulationChart = _.cloneDeep($scope.stockChart);
                    $scope.backOrderSimulationChart.options = stockUtil.getOptions(function (ev) { console.log(ev) });

                    $scope.oldAgedSimulationChart = _.cloneDeep($scope.stockChart);
                    $scope.oldAgedSimulationChart.options = stockUtil.getOptions(function (ev) { console.log(ev) });

                    $scope.backOrderSimulationChart.data.push(stockUtil.createLine(results[1].simulation6, "#ffbf01", "Simulation 6"))
                    $scope.backOrderSimulationChart.data.push(stockUtil.createLine(results[1].simulation5, "#5bc606", "Simulation 5"))
                    $scope.backOrderSimulationChart.data.push(stockUtil.createLine(results[1].simulation4, "#242424", "Simulation 4"))

                    $scope.oldAgedSimulationChart.data.push(stockUtil.createLine(results[1].simulation9, "#ffbf01", "Simulation 9"))
                    $scope.oldAgedSimulationChart.data.push(stockUtil.createLine(results[1].simulation8, "#5bc606", "Simulation 8"))
                    $scope.oldAgedSimulationChart.data.push(stockUtil.createLine(results[1].simulation7, "#242424", "Simulation 7"))
                    // -----

                    // simulation
                    $scope.stockChart.data.push(stockUtil.createLine(results[1].simulation3, "#ff7701", "Simulation 3"));
                    $scope.stockChart.data.push(stockUtil.createLine(results[1].simulation2, "green", "Simulation 2"));
                    $scope.stockChart.data.push(stockUtil.createLine(results[1].simulation1, "black", "Simulation 1"));


                    stockChartCache = _.cloneDeep($scope.stockChart); // caches data for future loads
                    stockService.setChart($scope.stockChart);
                });
        }
    }

    /**
     * User Simulation
     */
    function altUserSimuationChart(average) {
        if (average) {
            $scope.currentSimulatedValue = average

            let loadingAlert = toastr
                .info('<i class="fa fa-refresh fa-spin"></i> Generating simulation',
                'Info',
                { "timeOut": 0, "extendedTimeOut": 0 })

            stockService.getUserSimulationChart(materialId, average)
                .then(result => {
                    toastr.clear(loadingAlert)

                    $scope.userSimulationChart = _.cloneDeep($scope.stockChart)

                    $scope.userSimulationChart.data = _.filter($scope.userSimulationChart.data, element => {
                        return (element.key && _.toString(element.key) == 'Stock')
                    })

                    // bars
                    $scope.userSimulationChart.data.push(stockUtil.createBar({ media_vendas: average / 30, nome_material: $scope.currentMaterial }, "#e98a7e"));
                    $scope.userSimulationChart.data.push(stockUtil.createBar({ media_vendas: average / 30, nome_material: $scope.currentMaterial }, "#e2c391"));
                    $scope.userSimulationChart.data.push(stockUtil.createBar({ media_vendas: average / 30, nome_material: $scope.currentMaterial }, "#87d0e2"));

                    $scope.userSimulationChart.data.push(stockUtil.createReferenceLine(result, average / 30, 0, "red", true));
                    $scope.userSimulationChart.data.push(stockUtil.createReferenceLine(result, average / 30, 30, "#5a6e82", true));
                    $scope.userSimulationChart.data.push(stockUtil.createReferenceLine(result, average / 30, 60, "#5a6e82", true));
                    $scope.userSimulationChart.data.push(stockUtil.createReferenceLine(result, average / 30, 49, "#0073b7"));

                    $scope.userSimulationChart.data.push(stockUtil.createLine(result.simulation3, "#ff7701", "Simulation 3"));
                    $scope.userSimulationChart.data.push(stockUtil.createLine(result.simulation2, "green", "Simulation 2"));
                    $scope.userSimulationChart.data.push(stockUtil.createLine(result.simulation1, "black", "Simulation 1"));

                })
        }
    }

    function createUserSimulationChart(simulatedSales) {

        if (!simulatedSales) {
            return alert.error('Please enter a value to simulate')
        }
        let points = {};
        const sales = $scope.stockItem.media_vendas * 30;
        // simulatedSales = $scope.userChartInput.simulatedAvgSales
        stockService.getChart(materialId)
            .then(result => {
                points = result;

                // points.simulation1 = dateToValue(points.simulation1)

                points.simulation1 = createUserSimulation(points.simulation1, simulatedSales)

            })

        function createUserSimulation(points, simulatedSales) {
            // dates become values
            points = dateToValue(points)
            points = addPODiffs(points)

            const p1 = points[1];
            const p2 = points[2];

            const slope = slopeFromPoints(p1, p2)
            const newSlope = calculateEquivalentSlope(sales, slope, simulatedSales)
            console.log('points:', points);
            console.log('slope:', slope);
            console.log('new slope:', newSlope);

            let refPoint = points[0]
            let newPoints = _.map(points, (p, index) => {
                const isLast = _.findLastIndex(points) === points.length
                const isFirst = index === 0;
                const isBetween = !isFirst && !isLast

                if (isFirst) {
                    return p;
                } if (isBetween && p.point_order === 2) {
                    refPoint = p
                    p.y = points[index - 1].y + p.poQty

                    return p
                }
                if (isBetween && p.point_order != 2) {
                    let pX = p.x
                    let result = calculatePoint(refPoint, newSlope, pX)
                    p.x = result.x
                    p.y = result.y

                    return p
                }

                return p
            })

            newPoints = revertDateValues(newPoints)


            console.log('new points: ', newPoints);

            let userChart = _.cloneDeep($scope.stockChart)

            let t = newPoints
            userChart.data.push(stockUtil.createLine(t, "blue", "Simulation 99"))

            $scope.userSimulationChart = userChart
        }

        function addPODiffs(points) {
            return _.map(points, (p, index) => {
                if (p.point_order == 2) {
                    p.poQty = p.y - points[index - 1].y
                }
                return p
            })
        }

        function slopeFromPoints(p1, p2) {
            return (p2.y - p1.y) / (p2.x - p1.x)
        }

        function revertDateValues(points) {
            return _.map(points, p => {
                let pDay = new Date(p.day);
                p.x = pDay
                return p
            });
        }

        function dateToValue(points) {
            let i = 0;
            return _.map(points, (p, index) => {
                console.log('-----------avaliando ponto----------');
                const pX = p.x
                p.day = new Date(pX)
                let isAfterPO = (points[index - 1] && points[index - 1].point_order == 2)
                let isBeforePO = (points[index + 1] && points[index + 1].point_order == 2)

                if (points[index - 1] && p.point_order != 2) {
                    let d1 = moment(points[index - 1].day).format('YYYY-MM-DD')
                    let d2 = moment(p.day).format('YYYY-MM-DD')
                    i = i + Math.abs(moment(d1).diff(moment(d2), 'days'))
                }
                p.x = i
                return p
            })
        }

        function calculateEquivalentSlope(actualSales, actualSalesSlope, simulatedSales) {
            return (actualSalesSlope * simulatedSales) / actualSales;
        }


        function calculatePoint(point, slope, x) {
            let y = point.y + (slope * (x - point.x))
            if (y < 0) y = 0
            return { x: x, y: y }
        }

    }

    function createBackOrderSimulation() {
        // alert.info('This feature is undergoing maintenance and will available soon')
    }

    /**
     * Geochart (Regional Sales)
     */
    function applyDateFilter(event) {
        const start = moment(event.model.startDate).format('YYYY-MM-DD');
        const end = moment(event.model.endtDate).format('YYYY-MM-DD');

        createGeochart(start, end);
    }

    function createGeochart(startDate, endDate) {
        $scope.geochartLoading = true;
        if (regionalSalesCache && !(startDate)) {
            // stockUtil.drawGeochart(regionalSalesCache, () => $scope.geochartLoading = false);
        } else {
            stockService.getRegionalSalesChart(materialId, startDate, endDate)
                .then(result => {
                    const hasSales = _.isArray(result) && !_.isEmpty(result);
                    if (!hasSales) alert.error("No sales for this period");
                    if (hasSales) {
                        regionalSalesCache = result;
                        stockUtil.drawGeochart(result, () => $scope.geochartLoading = false);
                    }
                })
        }
    }

    /**
     * Sales Chart (Monthly Sales)
     */


    let salesChartData = void 0;

    $scope.initSalesChart = () => {
        if (!salesChartData) {
            getSalesChartData()
                .then(getSalesInfo)
                .then(create0To12Chart)

        }
    }

    function getSalesChartData() {
        const twoYearsBack = moment().subtract(23, 'month').format('YYYY-MM-DD');
        const lastMonth = moment().format('YYYY-MM-DD');
        $scope.salesChartLoading = true;
        return stockService.getSalesChart(materialId, twoYearsBack, lastMonth)
            .then(data => {
                $scope.salesChartLoading = false;
                salesChartData = _.cloneDeep(data);
                return data;
            })
            .catch(err => { $scope.salesChartLoading = false; return err; })
    }

    function createStockSalesChart() {
        if (salesStockCache) {
            $scope.salesChart = {};
            $scope.salesChart = _.cloneDeep(salesStockCache);
            return;
        }

        $scope.stockSalesChartLoading = true;
        let dates = [];
        let cd = { data: [], options: {} };
        let yMin, yMax;
        yMin = _.min(_.map(salesChartData, 'quantidade_sqft'));
        yMax = _.max(_.map(salesChartData, 'quantidade_sqft'));
        if (yMin > 0) yMin = 0;

        // options
        cd.options = stockUtil.salesChartOptionsLine;
        cd.options.chart.xAxis.ticks = 12;
        cd.options.chart.yDomain = [yMin, yMax];
        cd.options.chart.xAxis.tickFormat = function (d) { return d3.time.format("%b")(new Date(dates[d])); }
        cd.options.chart.bars = {};
        cd.options.chart.bars.yDomain = [yMin, yMax];
        cd.options.chart.color = ['#39CCCC'];

        // data
        cd.data.push({})
        cd.data[0].color = '#0073b7';
        cd.data[0].type = 'line'
        cd.data[0].key = 'Sales'
        // cd.data[0].yAxis = 1;
        let i = 0;
        cd.data[0].values = _.map(_.slice(salesChartData, 12), v => {
            dates[i] = new Date(v.ref_date);
            return { x: i++, y: v.quantidade_sqft };
        });

        $scope.salesChart = cd;

        let endDate = moment().format('YYYY-MM-DD');
        let startDate = moment().startOf('month').subtract(11, 'month').format('YYYY-MM-DD');

        stockService.getStockHistory(materialId, startDate, endDate)
            .then(result => {
                $scope.stockSalesChartLoading = false;
                let historyValues = _.map(result, m => { return { x: 0, y: m.media_mensal } });

                $scope.salesChart.data.push({})
                $scope.salesChart.data[1].color = '#D81B60';
                $scope.salesChart.data[1].type = 'line'
                $scope.salesChart.data[1].key = 'Stock'
                // $scope.salesChart.data[1].yAxis = 1;
                $scope.salesChart.data[1].classed = 'dashed-line';

                // enable if bars
                // $scope.salesChart.data.push({});
                // $scope.salesChart.options.chart.x = function (d, i) { return i };
                // $scope.salesChart.data[1].key = 'Stock'
                // $scope.salesChart.data[1].bar = true;
                // $scope.salesChart.data[1].yAxis = 1;

                let maxHistoryValues = _.max(_.map(result, 'media_mensal'))
                if (yMax < maxHistoryValues) {
                    yMax = maxHistoryValues;
                }

                $scope.salesChart.options.chart.yDomain = [yMin, yMax];
                // $scope.salesChart.options.chart.bars.yDomain = [yMin, yMax];

                let history12Months = _.concat(
                    _.fill(Array(12 - historyValues.length), { x: 0, y: 0 }),
                    historyValues
                );
                let i = 0;
                $scope.salesChart.data[1].values = _.map(history12Months, h => {
                    return { x: i++, y: h.y }
                });

                salesStockCache = _.cloneDeep($scope.salesChart);
            }).catch(err => { $scope.stockSalesChartLoading = false; return err })
    }

     function linearRegression(y, x) {
        // http://www.localwisdom.com/blog/2014/01/get-trend-line-javascript-graph-linear-regression/

        var lr = {}
        var n = y.length
        var sum_x = 0
        var sum_y = 0
        var sum_xy = 0
        var sum_xx = 0
        var sum_yy = 0

        for (var i = 0; i < y.length; i++) {

            sum_x += x[i];
            sum_y += y[i];
            sum_xy += (x[i] * y[i]);
            sum_xx += (x[i] * x[i]);
            sum_yy += (y[i] * y[i]);
        }

        lr['slope'] = (n * sum_xy - sum_x * sum_y) / (n * sum_xx - sum_x * sum_x);
        lr['intercept'] = (sum_y - lr.slope * sum_x) / n;
        lr['r2'] = Math.pow((n * sum_xy - sum_x * sum_y) / Math.sqrt((n * sum_xx - sum_x * sum_x) * (n * sum_yy - sum_y * sum_y)), 2);

        return lr
    }

    function create0To12Chart() {

        let dates = [];
        let cd = { data: [], options: {} };
        let yMin, yMax;
        yMin = _.min(_.map(salesChartData, 'quantidade_sqft'));
        yMax = _.max(_.map(salesChartData, 'quantidade_sqft'));
        if (yMin > 0) yMin = 0;

        // options
        cd.options = stockUtil.getSalesChartOptions();
        cd.options.chart.xAxis.ticks = 12;
        cd.options.chart.yDomain = [yMin, yMax];
        cd.options.chart.xAxis.tickFormat = function (d) { return d3.time.format("%b")(new Date(dates[d])); }


        // data
        cd.data.push({})
        cd.data[0].color = '#0073b7';
        cd.data[0].type = 'line'
        cd.data[0].key = 'Sales'
        cd.data[0].yAxis = 1;
        let i = 0;
        cd.data[0].values = _.map(_.slice(salesChartData, 12), v => {
            dates[i] = new Date(v.ref_date);
            return { x: i++, y: v.quantidade_sqft };
        })


           //
        // Trend line
        //
        let salesLinePoints = _.initial(cd.data[0].values)

        const known_x = _.map(salesLinePoints, 'x')
        const known_y = _.map(salesLinePoints, 'y')
        const result = linearRegression(known_y, known_x)

        cd.data.push({})

        if (result.slope < 0) cd.data[1].color = '#ff4040'
        if (result.slope >= 0) cd.data[1].color = '#16dc00'

        cd.data[1].type = 'line'
        cd.data[1].key = 'Trend'
        cd.data[1].yAxis = 1;
        cd.data[1].classed = 'dashed-line';
        let j = 0;
        cd.data[1].values = []

        cd.data[1].values.push({
            x: _.head(salesLinePoints).x,
            y: result.intercept
        })

        cd.data[1].values.push({
            x: _.last(salesLinePoints).x,
            y: (salesLinePoints.length * result.slope) + result.intercept
        })

        $scope.salesChart = cd;

    }

    function create0To24Chart() {
        let dates = [];
        let cd = { data: [{}], options: {} };
        let yMin, yMax;
        yMin = _.min(_.map(salesChartData, 'quantidade_sqft'));
        yMax = _.max(_.map(salesChartData, 'quantidade_sqft'));
        if (yMin > 0) yMin = 0;

        // options
        cd.options = stockUtil.getSalesChartOptions();
        cd.options.chart.xAxis.ticks = 24;
        cd.options.chart.yDomain = [yMin, yMax];
        cd.options.chart.xAxis.tickFormat = function (d) { return d3.time.format("%b")(new Date(dates[d])); }

        //data
        cd.data[0].color = '#0073b7';
        cd.data[0].type = 'line'
        cd.data[0].key = 'Sales'
        cd.data[0].yAxis = 1;
        let i = 0;
        cd.data[0].values = _.map(salesChartData, v => {
            dates[i] = new Date(v.ref_date);
            return { x: i++, y: v.quantidade_sqft };
        })

        cd.data.push({})
        cd.data[1].color = '#b5bbc8';
        cd.data[1].type = 'line'
        cd.data[1].key = 'Period division'
        cd.data[1].yAxis = 1;
        // cd.data[1].classed = '1';
        cd.data[1].values = [{ x: [12], y: yMax },
        { x: [12], y: 0 }]

         //
        // Trend line 1st Year
        //
        const salesLinePoints1stYear = _.take(cd.data[0].values, 13)

        const known_x = _.map(salesLinePoints1stYear, 'x')
        const known_y = _.map(salesLinePoints1stYear, 'y')
        const result = linearRegression(known_y, known_x)

        cd.data.push({})

        if (result.slope < 0) cd.data[2].color = '#ff4040'
        if (result.slope >= 0) cd.data[2].color = '#16dc00'

        cd.data[2].type = 'line'
        cd.data[2].key = 'Trend 1st Year'
        cd.data[2].yAxis = 1;
        cd.data[2].classed = 'dashed-line';
        cd.data[2].values = []

        cd.data[2].values.push({
            x: _.head(salesLinePoints1stYear).x,
            y: result.intercept
        })

        cd.data[2].values.push({
            x: _.last(salesLinePoints1stYear).x,
            y: (salesLinePoints1stYear.length * result.slope) + result.intercept
        })


         //
        // Trend line 2nd Year
        //
        const salesLinePoints2ndYear = _.takeRight(cd.data[0].values, 12)
        salesLinePoints2ndYear.pop()

        const known_x2 = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]
        const known_y2 = _.map(salesLinePoints2ndYear, 'y')
        const result2 = linearRegression(known_y2, known_x2)

        cd.data.push({})

        if (result2.slope < 0) cd.data[3].color = '#ff4040'
        if (result2.slope >= 0) cd.data[3].color = '#16dc00'

        cd.data[3].type = 'line'
        cd.data[3].key = 'Trend 2nd Year'
        cd.data[3].yAxis = 1;
        cd.data[3].classed = 'dashed-line';
        cd.data[3].values = []

        cd.data[3].values.push({
            x: _.head(salesLinePoints2ndYear).x,
            y: result2.intercept
        })

        cd.data[3].values.push({
            x: _.last(salesLinePoints2ndYear).x,
            y: (salesLinePoints2ndYear.length * result2.slope) + result2.intercept
        })

        $scope.salesChart = cd;
    }

    function createComparisonChart() {
        let cd = { data: [{}, {}], options: {} };
        let dates = [];
        let yMin, yMax;
        yMin = _.min(_.map(salesChartData, 'quantidade_sqft'));
        yMax = _.max(_.map(salesChartData, 'quantidade_sqft'));
        if (yMin > 0) yMin = -5;

        cd.options = stockUtil.getSalesChartOptions();
        cd.options.chart.xAxis.tickFormat = function (d) { return d3.time.format("%b")(new Date(dates[d])); }
        cd.options.chart.yDomain = [yMin, yMax];

        // 0-12
        let i = 0;
        cd.data[0].color = '#0073b7';
        cd.data[0].type = 'line'
        cd.data[0].key = '0-12'
        cd.data[0].yAxis = 1;
        cd.data[0].values = _.map(_.slice(salesChartData, 12), v => {
            dates[i] = new Date(v.ref_date);
            return { x: i++, y: v.quantidade_sqft };
        })
        cd.data[0].yAxis = 1;

        // 0-24
        i = 0;
        cd.data[1].color = '#dd4b39';
        cd.data[1].type = 'line'
        cd.data[1].key = '12-24'
        cd.data[1].yAxis = 1;
        cd.data[1].values = _.map(_.take(salesChartData, 12), v => {
            dates[i] = new Date(v.ref_date);
            return { x: i++, y: v.quantidade_sqft };
        })
        cd.data[0].yAxis = 1;

        $scope.salesChart = cd;
    }

    function getSalesInfo(data) {
        let y2 = _.meanBy(_.take(_.map(salesChartData, 'quantidade_sqft'), 12));
        let y1 = _.meanBy(_.slice(_.map(salesChartData, 'quantidade_sqft'), 12));

        $scope.sales = stockUtil.getSalesBehavior(y1, y2);
        $scope.sales.firstYearAverage = _.toString(y1);
        $scope.sales.secondYearAverage = _.toString(y2);
    }

    function clickMaterial(name) {
        stockService.currentMaterial = name;
    }


    let regionalStockCache;
    function createRegionalStockChart() {
        if (regionalStockCache) return;

        stockService.getRegionalStockChart(materialId)
            .then(result => {
                regionalStockCache = result
                stockUtil.drawRegionalStockChart(result, () => { })
            })

    }
    $scope.createRegionalStockChart = createRegionalStockChart

    $scope.clickMaterial = clickMaterial;

    $scope.createGeochart = createGeochart;
    $scope.setActiveTab = stockService.setActiveTab;
    $scope.createSimulationChart = createSimulationChart;
    $scope.createUserSimulationChart = createUserSimulationChart;
    $scope.createBackOrderSimulation = createBackOrderSimulation;

    $scope.create0To12Chart = create0To12Chart;
    $scope.create0To24Chart = create0To24Chart;
    $scope.createComparisonChart = createComparisonChart;
    $scope.createStockSalesChart = createStockSalesChart;

    $scope.altUserSimuationChart = altUserSimuationChart

}
app.controller('StockDetailController', StockDetailController);
stockService.$inject = ['$http', '$httpParamSerializer']
function stockService($http, $httpParamSerializer) {
    let stockList;
    let storedChart = {};
    let activeTab = 1;
    let currentMaterial = '';

    const initChart = () => {
        if (storedChart && storedChart.data && storedChart.options) {
            return storedChart;
        }
        return {};
    }

    const setChart = (chart) => storedChart = chart;


    // helpers for active tab control
    const setActiveTab = (index) => activeTab = index;
    const getActiveTab = () => activeTab;

    // finds list of materials and their critical leveles
    const find = () => {
        if (stockList) return Promise.resolve(stockList);

        return $http.get('/api/stock/')
            .then(res => res.data)
            .then(stock => {
                angular.copy(stock, stockList); return stock;
            })
            .catch(errorHandler);
    }

    // finds statistics, used to plot chart
    const findStats = () => {
        return $http.get('/api/stock/stats')
            .then(res => res.data)
            .catch(errorHandler);
    }

    // get information about the item itself (forecast orders, average sales etc)
    const get = (materialId) => {
        return $http.get('/api/stock/' + materialId)
            .then(res => res.data)
            .catch(errorHandler);
    }

    // finds and breaks simulation chart into objects
    const getChart = (materialId) => {
        return $http.get('/api/stock/' + materialId + '/chart')
            .then(res => res.data)
            .then(charts => {

                charts.history = _.map(charts.history, (coord) => { coord.x = moment(coord.x).toDate(); return coord });
                charts.simulation = _.map(charts.simulation, (coord) => {
                    // coord.x = moment(coord.x).toDate(); 
                    // console.log(coord.x,new Date(moment(coord.x).tz('America/Sao_Paulo').format('YYYY-MM-DD HH:mm')));
                    // coord.x = new Date(moment(coord.x).tz('America/Sao_Paulo').format('YYYY-MM-DD HH:mm')); 
                    // coord.x = moment(coord.x).utcOffset('-03:00').toDate()//format('YYYY-MM-DD HH:mm')); 

                    const d = new Date()
                    const userOffset = d.getTimezoneOffset() * 60000
                    const brazilOffset = 2 * 60 * 60000 * (-1)
                    coord.x = new Date(new Date(coord.x).getTime() + userOffset + brazilOffset)

                    return coord
                });
                charts.simulation1 = _.filter(charts.simulation, (coord) => coord.id == 1);
                charts.simulation2 = _.filter(charts.simulation, (coord) => coord.id == 2);
                charts.simulation3 = _.filter(charts.simulation, (coord) => coord.id == 3);
                charts.simulation4 = _.filter(charts.simulation, (coord) => coord.id == 4);
                charts.simulation5 = _.filter(charts.simulation, (coord) => coord.id == 5);
                charts.simulation6 = _.filter(charts.simulation, (coord) => coord.id == 6);
                charts.simulation7 = _.filter(charts.simulation, (coord) => coord.id == 7);
                charts.simulation8 = _.filter(charts.simulation, (coord) => coord.id == 8);
                charts.simulation9 = _.filter(charts.simulation, (coord) => coord.id == 9);

                delete charts.simulation;

                return charts;
            })
            .catch(errorHandler);
    }

    const getRegionalSalesChart = (materialId, startDate, endDate) => {
        let defaultEndDate = moment().format('YYYY-MM-DD');
        let defaultStartDate = moment().subtract(12, 'month').endOf('month').format('YYYY-MM-DD');

        let query = "";
        if (startDate && endDate) query = $httpParamSerializer({ start: startDate, end: endDate });
        if (!startDate && !endDate) query = $httpParamSerializer({ start: defaultStartDate, end: defaultEndDate });

        return $http.get('/api/stock/' + materialId + '/sales-chart/regional?' + query)
            .then(res => res.data)
            .catch(errorHandler);
    }

    const getSalesChart = (materialId, startDate, endDate) => {
        let query = "";
        if (startDate && endDate) query = $httpParamSerializer({ start: startDate, end: endDate });

        return $http.get('/api/stock/' + materialId + '/sales-chart?' + query)
            .then(res => res.data)
            .catch(errorHandler);
    }

    const getStockPOs = (materialId, eta) => {
        let url = '/api/stock/' + materialId + '/po';
        if (eta) url += '?eta_date=' + moment(eta).format('YYYY-MM-DD').toString();

        return $http.get(url)
            .then(res => res.data)
            .catch(errorHandler);
    }

    const getStockPOsByInspection = (materialId, inspectionId) => {
        let url = '/api/stock/' + materialId + '/po/' + inspectionId;

        return $http.get(url)
            .then(res => res.data)
            .catch(errorHandler);
    }

    const getStockHistory = (materialId, startDate, endDate) => {
        let query = void 0;
        if (startDate && endDate) query = $httpParamSerializer({ start: startDate, end: endDate });

        return $http.get('/api/stock/' + materialId + '/history?' + query || '')
            .then(res => res.data)
            .catch(errorHandler);
    }

    const getUserSimulationChart = (materialId, average) => {
        if (!average || !materialId) { alert.error('Please fill in all the data'); return; }

        return $http.get('/api/stock/' + materialId + '/chart/simulation?avg=' + average)
            .then(res => res.data)
            .then(charts => {

                // charts.history = _.map(charts.history, (coord) => { coord.x = moment(coord.x).toDate(); return coord });
                charts.simulation = _.map(charts, (coord) => {
                    coord.x = moment(coord.x).utcOffset('-03:00').toDate()//format('YYYY-MM-DD HH:mm')); 
                    return coord
                });
                charts.simulation1 = _.filter(charts, (coord) => coord.id == 1);
                charts.simulation2 = _.filter(charts, (coord) => coord.id == 2);
                charts.simulation3 = _.filter(charts, (coord) => coord.id == 3);
                charts.simulation4 = _.filter(charts, (coord) => coord.id == 4);
                charts.simulation5 = _.filter(charts, (coord) => coord.id == 5);
                charts.simulation6 = _.filter(charts, (coord) => coord.id == 6);

                // delete charts.simulation;

                return charts;
            })
            .catch(errorHandler)
    }

    const getDistributionCenterStock = (materialId) => {

        return $http.get('/api/stock/' + materialId + '/location')
            .then(res => res.data)
            .catch(errorHandler)
    }

    const getRegionalStockChart = (materialId) => {

        return $http.get('/api/stock/' + materialId + '/regional')
            .then(res => res.data)
            .catch(errorHandler);
    }

    return {
        currentMaterial,
        find,
        findStats,
        get,
        getChart,
        getSalesChart,
        getRegionalSalesChart,
        getRegionalStockChart,
        initChart,
        setChart,
        setActiveTab,
        getActiveTab,
        getStockPOs,
        getStockHistory,
        getStockPOsByInspection,
        getUserSimulationChart,
        getDistributionCenterStock
    };
}

app.service('stockService', stockService);


// util
stockUtil.$inject = ['$window'];
function stockUtil($window) {

    const getDatepickerOptions = (applyHandler) => {
        const daterPickerOptions =
            {
                eventHandlers: {
                    'apply.daterangepicker': applyHandler
                },
                ranges: {
                    'This Month': [moment().startOf('month'), moment().endOf('month')],
                    'Last 2 Months': [moment().subtract(1, 'month'), moment()],
                    'Last 3 Months': [moment().subtract(3, 'month'), moment()],
                    'Last 6 Months': [moment().subtract(6, 'month'), moment()],
                    'Last 12 Months': [moment().subtract(12, 'month'), moment()]
                },
                locale: {
                    customRangeLabel: ''
                }
            }
        return daterPickerOptions
    }

    const drawGeochart = (chartData, cb) => {
        $window.google.charts.load('upcoming', { 'packages': ['geochart'] });
        $window.google.charts.setOnLoadCallback(drawMarkersMap);

        function drawMarkersMap() {
            var columns = ['Latitude', 'Longitude', 'City', 'Sales (sq. ft.)'];

            let table = [columns];

            _.forEach(chartData, (r) => table.push([r.latitude, r.longitude, r.cidade, r.vendas_sqft]))

            var data = google.visualization.arrayToDataTable(table)

            var options = {
                region: 'US',
                displayMode: 'region',
                resolution: 'provinces',
                colorAxis: {
                    colors: ['#fdce7d', 'orange', 'red', 'darkred']
                }
                , backgroundColor: '#c0d1e8',
                datalessRegionColor: '#eae3d3',
                defaultColor: '#f5f5f5'
            };

            var chart = new $window.google.visualization.GeoChart(angular.element('#chart_div')[0]);
            chart.draw(data, options);
            cb();
        };
    }


    const getOptions = (clickHandler) => {
        return {
            chart: {
                type: 'multiChart', height: 450, margin: { top: 30, right: 60, bottom: 50, left: 70 },
                duration: 500, color: d3.scale.category10().range(),
                showLegend: false,
                // average: function (d) { console.log(d); return d / 18; },
                xAxis: {
                    ticks: 18,
                    axisLabel: 'Time (days)', rotateLabels: -30,
                    tickFormat: function (d) { return d3.time.format("%b %d")(moment(d).utcOffset('-02:00').toDate()); }
                },
                yAxis1: {
                    axisLabel: 'Quantity',
                    tickFormat: function (d) { return d3.format(',.0f')(d); }
                },
                yAxis2: {},
                lines1: {
                    dispatch: {
                        elementClick: clickHandler
                    }
                },
                stack1: { interactive: false }
            }
        };
    };

    const getSalesChartOptions = () => salesChartOptions;

    const salesChartOptions = {
        chart: {
            type: 'linePlusBarChart', height: 450, margin: { top: 30, right: 60, bottom: 50, left: 70 },
            duration: 500, color: d3.scale.category10().range(),
            showLegend: false,
            average: function (d) { console.log(d); return d / 18; },
            xAxis: {
                // ticks: 12,
                axisLabel: 'Time (months)', showMaxMin: false, rotateLabels: -30,
                // tickFormat: function (d) { return d3.time.format("%b %d")(new Date(d)) }
            },
            y1Axis: {
                axisLabel: 'Sales in Sq. Ft', showMaxMin: false,
                tickFormat: function (d) { return d3.format(',.0f')(d); }
            }
        }
    }

    const salesChartOptionsLine = {
        chart: {
            type: 'lineChart', height: 450, margin: { top: 30, right: 60, bottom: 50, left: 70 },
            duration: 500, color: d3.scale.category10().range(),
            showLegend: false,
            useInteractiveGuideline: true,
            average: function (d) { console.log(d); return d / 18; },
            xAxis: {
                // ticks: 12,
                axisLabel: 'Time (months)', showMaxMin: false,
                // tickFormat: function (d) { return d3.time.format("%b %d")(new Date(d)) }
            },
            yAxis: {
                axisLabel: 'Sales in Sq. Ft', showMaxMin: false,
                tickFormat: function (d) { return d3.format(',.0f')(d); }
            }
        }
    }

    const createLine = (values, color, key) => {
        let line = {};
        line.values = values;
        line.type = "line";
        line.key = key;
        line.color = color;
        line.yAxis = 1;
        line.strokeWidth = 2;

        return line;
    }

    const createBar = (stockItem, color) => {
        return {
            values: [
                { x: moment().subtract(1, 'months').toDate(), y: (stockItem.media_vendas * 30) },
                { x: moment().add(3, 'months').toDate(), y: (stockItem.media_vendas * 30) }
            ],
            key: stockItem.nome_material, color: color, type: 'area', yAxis: 1
        }
    }

    const createReferenceLine = (charts, averageSales, daysFromNow, color, isDashed) => {
        const s1Height = _.max(_.map(charts.simulation1, (coord) => coord.y));
        const s2Height = _.max(_.map(charts.simulation2, (coord) => coord.y));
        const s3Height = _.max(_.map(charts.simulation3, (coord) => coord.y));
        const historyHeight = _.max(_.map(charts.history, (coord) => coord.y));
        const salesHeight = averageSales * 30 * 3;

        const height = _.max([s1Height, s2Height, s3Height, historyHeight, salesHeight]);

        const lastStockDate = _.max(_.map(charts.history, (coord) => coord.x))

        return {
            values: [
                { x: moment(lastStockDate).add(daysFromNow, 'days').toDate(), y: 0 },
                { x: moment(lastStockDate).add(daysFromNow, 'days').toDate(), y: height }
            ],
            key: moment().add(daysFromNow, 'days').toDate(), color: color, type: 'line', yAxis: 1, classed: isDashed ? 'dashed-line' : ''
        }
    }

    const createSalesChart = (coords) => {
        let chartData = {};
        chartData.data = [];
        chartData.labels = [];

        chartData.colors = ['#3c8dbc', '#dd4b39'];
        chartData.labels = _.map(coords, (r) => r.mes);
        chartData.data = _.map(coords, month => month.quantidade_sqft)

        return chartData
    }

    const getSalesBehavior = (meanFirstYear, meanSecondYear) => {
        const y1 = _.toNumber(meanFirstYear);
        const y2 = _.toNumber(meanSecondYear);

        let className = '';
        let text = 'Sales ';

        if (y1 < y2) {
            text += 'decreased ';
            className = 'text-red'
        }
        if (y1 > y2) {
            text += 'increased ';
            className = 'text-green'
        }
        if (y1 === 0 && y2 === 0) {
            text = 'No sales record'
            return;
        }

        const rate = Math.abs(_.round(((y1 / y2) - 1) * 100));

        if (_.isFinite(rate)) {
            text += rate + '%';
        } else {
            className = 'text-black'
            text = 'Not enough data to calculate'
        }



        return { text, className };
    }

    const drawRegionalStockChart = (chartData, cb) => {
        $window.google.charts.load('upcoming', { 'packages': ['geochart'] });
        $window.google.charts.setOnLoadCallback(drawMarkersMap);

        function drawMarkersMap() {
            var columns = ['Latitude', 'Longitude', 'City', 'Quantity (sq. ft.)'];

            let table = [columns];

            _.forEach(chartData, (r) => table.push([r.latitude, r.longitude, r.cidade, r.estoque_quantidade]))

            var data = google.visualization.arrayToDataTable(table)

            var options = {
                region: 'US',
                displayMode: 'region',
                resolution: 'provinces',
                colorAxis: {
                    colors: ['#6fa8cc', '#272f71', '#151f73', '#000d75']
                }
                , backgroundColor: '#c0d1e8',
                datalessRegionColor: '#eae3d3',
                defaultColor: '#f5f5f5'
            };

            var chart = new $window.google.visualization.GeoChart(angular.element('#chart_div_stock')[0]);
            chart.draw(data, options);
            cb();
        }
    }

    return {
        getOptions,
        createLine,
        createBar,
        createReferenceLine,
        getDatepickerOptions,
        drawGeochart,
        drawRegionalStockChart,
        createSalesChart,
        getSalesBehavior,
        getSalesChartOptions,
        salesChartOptionsLine
    }
}
app.service('stockUtil', stockUtil);